import React, { useState } from "react";
import { FAQS } from "../mock";
import { Plus, Minus } from "lucide-react";

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section className="relative bg-[var(--lc-cream)] py-20 lg:py-28">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="eyebrow text-[var(--lc-moss)] mb-5">FAQ</div>
            <h2 className="font-serif-display text-[clamp(34px,4.8vw,64px)] leading-[1] font-light sticky top-32">
              Questions? <span className="italic">We’ve got answers.</span>
            </h2>
          </div>
          <div className="lg:col-span-7">
            <div className="border-t border-[var(--lc-ink)]">
              {FAQS.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div key={f.q} className="border-b border-[var(--lc-ink)]">
                    <button
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      className="w-full flex items-center justify-between py-6 lg:py-7 text-left gap-6"
                    >
                      <span className="font-serif-display text-[22px] lg:text-[28px] leading-tight">
                        {f.q}
                      </span>
                      <span className={`shrink-0 grid place-items-center w-10 h-10 rounded-full border border-[var(--lc-ink)] transition-colors ${isOpen ? "bg-[var(--lc-ink)] text-[var(--lc-cream)]" : ""}`}>
                        {isOpen ? <Minus className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                      </span>
                    </button>
                    <div className={`grid transition-all duration-300 ease-out ${isOpen ? "grid-rows-[1fr] opacity-100 pb-6" : "grid-rows-[0fr] opacity-0"}`}>
                      <div className="overflow-hidden">
                        <p className="text-[15px] leading-relaxed text-[var(--lc-muted)] max-w-2xl">
                          {f.a}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
